import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone } from 'lucide-react';
import { styles } from './Footer.styles';

export const Footer: React.FC = () => {
    return (
        <footer style={styles.footerWrapper}>
            <div style={styles.gridContainer}>
                <div>
                    <h3 style={styles.brandHeading}>
                        EduGlobal<span style={styles.brandHighlight}>SaaS</span>
                    </h3>
                    <p style={styles.brandDescription}>
                        Empowering global education consultancies with enterprise multi-tenant technology, streamlining student placements, applications, and university partnerships.
                    </p>
                </div>

                <div>
                    <h4 style={styles.columnHeading}>Platform</h4>
                    <ul style={styles.linkList}>
                        <li><Link to="/countries" style={styles.listLinkItem}>Study Destinations</Link></li>
                        <li><Link to="/universities" style={styles.listLinkItem}>Partner Universities</Link></li>
                        <li><Link to="/programs" style={styles.listLinkItem}>Course Catalog</Link></li>
                        <li><Link to="/smart-course-finder" style={styles.listLinkItem}>AI Smart Course Finder</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 style={styles.columnHeading}>Organizations</h4>
                    <ul style={styles.linkList}>
                        <li><Link to="/register/consultancy" style={styles.listLinkItem}>Register Consultancy</Link></li>
                        <li><Link to="/register/student" style={styles.listLinkItem}>Student Portal</Link></li>
                        <li><Link to="/login" style={styles.listLinkItem}>Consultancy Sign In</Link></li>
                        <li><Link to="/superadmin/dashboard" style={styles.listLinkItem}>Super Admin Portal</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 style={styles.columnHeading}>Contact & Support</h4>
                    <div style={styles.contactGroup}>
                        <div style={styles.contactItem}>
                            <MapPin size={14} style={styles.contactIcon} />
                            <span>Global HQ, Education Tech Center</span>
                        </div>
                        <div style={styles.contactItem}>
                            <Mail size={14} style={styles.contactIcon} />
                            <span>support@eduglobalsaas.com</span>
                        </div>
                        <div style={styles.contactItem}>
                            <Phone size={14} style={styles.contactIcon} />
                            <span>+1 (800) 555-EDU-GLOBAL</span>
                        </div>
                    </div>
                </div>
            </div>

            <div style={styles.bottomBar}>
                <div>© 2026 EduGlobalSaaS Inc. All rights reserved. Enterprise Multi-Tenant Platform.</div>
                <div style={styles.bottomLinks}>
                    <Link to="/privacy" style={styles.listLinkItem}>Privacy Policy</Link>
                    <Link to="/terms" style={styles.listLinkItem}>Terms of Service</Link>
                    <Link to="/faq" style={styles.listLinkItem}>Security &amp; FAQ</Link>
                </div>
            </div>
        </footer>
    );
};
